(function(){
  var root = document.getElementById('dh');
  if(!root) return;

  // Mobile menu toggle
  var burger = root.querySelector('.dh-burger');
  var links = root.querySelector('.dh-links');
  if(burger && links){
    burger.addEventListener('click', function(){
      links.classList.toggle('open');
    });
    links.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){ links.classList.remove('open'); });
    });
  }

  // Smooth scroll for in-page anchors
  root.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href');
      if(id.length < 2) return;
      var el = root.querySelector(id);
      if(el){
        e.preventDefault();
        var y = el.getBoundingClientRect().top + window.pageYOffset - 74;
        window.scrollTo({top:y, behavior:'smooth'});
      }
    });
  });
})();
